import type { TileMapMetaProvider } from "game-common/tile_map_meta_provider"
import { Entity } from "game-common/models"
import type { ClientRenderable } from "./entity_rendering_manager"
import { entityDepth } from "./entity_depth"
import { applyFloorFall, floorFallForRendering } from "./effects/floor_fall"
import { applyStairTravel, stairTravelForRendering } from "./effects/stair_travel"

/** Placement, animation and depth must agree in every view, including budget-deferred frames. */
export function renderEntityFrame(entity: Entity, sprite: ClientRenderable, roomId?: string,
    canShowArrival = true, now = Date.now(), provider?: TileMapMetaProvider): void {
    sprite.updateRenderedLocationFrom(entity)
    const view = floorFallForRendering(entity, sprite, canShowArrival && (sprite.isReadyToShow?.() ?? true), now, roomId)
    sprite.zIndex = entityDepth(view, sprite.defaultZIndex, provider)
    sprite.doMovement(stairTravelForRendering(view, sprite, now, roomId))
    applyFloorFall(view, sprite, now)
    applyStairTravel(entity, sprite, now, roomId)
}
